module.exports = __webpack_public_path__ + "images/9de56c6c48e6e7f4e348b988bde38c2e.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/get_started/reviews_ilustration.png
// module id = 55
// module chunks = 24